import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { getInitials } from "@/lib/Utils/getInitials";
import { useActiveOrganisation } from "@/app/Organisations/Hooks/useActiveOrganisation";
import { useGlobalSupplier } from "@/app/Suppliers/Utils/useGlobalSupplier";

/**
 * Bare org URL (`/$tenant/$orgId`) landing screen: pick a supplier to drop into
 * its scope. The route guard only renders this when the org has more than one
 * supplier — a sole supplier auto-selects and an empty org goes to onboarding.
 */
export function SelectSupplierScreen() {
  const { activeOrganisation } = useActiveOrganisation();
  const {
    supplierList,
    actions: { setSupplier },
  } = useGlobalSupplier();

  return (
    <div className="flex h-full w-full max-w-md flex-col p-6">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900">Select supplier</h2>
        <p className="mt-1 text-sm text-gray-500">
          Choose a supplier in {activeOrganisation?.name ?? "this organisation"}{" "}
          to continue
        </p>
      </div>

      <ul className="divide-y divide-gray-100 overflow-y-auto rounded-md">
        {supplierList.map((supplier) => (
          <li key={supplier.id} className="w-full">
            <button
              className="focus:outline-hidden flex w-full items-center gap-3 px-4 py-3 text-left transition-colors hover:bg-gray-50 focus:bg-gray-50"
              onClick={() => setSupplier(supplier.id)}
            >
              <Avatar className="h-10 w-10 border border-gray-200">
                {(supplier.icon ?? supplier.logo)?.url ? (
                  <AvatarImage
                    src={(supplier.icon ?? supplier.logo)?.url}
                    alt={supplier.name}
                    className="bg-white object-contain"
                  />
                ) : null}
                <AvatarFallback className="bg-indigo-100 text-indigo-600">
                  {getInitials(supplier.name)}
                </AvatarFallback>
              </Avatar>
              <p className="flex-1 font-medium text-gray-900">
                {supplier.name}
              </p>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
